'use client'

import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import { ButtonContentLink } from 'fukku/Button/ContentLink'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useLogout } from 'logout/hooks/useLogout'

import styles from './LogoutLink.module.scss'

export const LogoutLink = () => {
	const { logout } = useLogout()
	const { t } = useLabels()

	const handleClickLogout = async () => {
		await logout()
		sendGenericEvent('account_signout')
	}

	return (
		<ButtonContentLink
			className={styles.logoutButton}
			data-testid='myAccount.logoutLink'
			onClick={handleClickLogout}
		>
			{t('profile.signOut.link')}
		</ButtonContentLink>
	)
}
